<div class="p-3">
  <div class="fw-bold fs-5">{{data.title||'Message'}}</div>
</div>
<div mat-dialog-content style="min-width: 300px;">
  <ng-container *ngFor="let msg of getMessages">
    <div [ngSwitch]="msg.tag" class="mb-3">
      <p *ngSwitchCase="'p'" [ngClass]="msg.style">
        {{msg.message||'Something went wrong. Please contact Administrator'}}
      </p>
      <a *ngSwitchCase="'a'" [href]="msg.href" class="underline" [ngClass]="msg.style" target="_blank" rel="noopener noreferrer">
        {{msg.message||'Something went wrong. Please contact Administrator'}}
      </a>
      <span *ngSwitchDefault [ngClass]="msg.style">
        {{msg.message||'Something went wrong. Please contact Administrator'}}
      </span>
    </div>
  </ng-container>
</div>
<div mat-dialog-content>
  <div class="text-end mt-3">
    <button class="btn btn-{{data.type||'primary'}} px-3" mat-dialog-close>OK</button>
  </div>
</div>